// src/pages/Admin/StatistiquesComptabilite/components/ComptaAccessDenied.jsx

import React from "react";
import { FaLock, FaShieldAlt } from "react-icons/fa";

export default function ComptaAccessDenied() {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-rose-200 bg-white shadow-sm dark:border-rose-500/20 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-rose-500 to-orange-500" />

      <div className="p-5 sm:p-6">
        <div className="flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-rose-50 text-rose-600 dark:bg-rose-500/10 dark:text-rose-300">
            <FaLock />
          </span>

          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-rose-500">
              Accès refusé
            </p>

            <h1 className="mt-1 text-2xl font-bold text-slate-900 dark:text-white">
              Statistiques de comptabilité
            </h1>

            <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Cette page est réservée aux administrateurs du club.
            </p>

            <div className="mt-4 inline-flex items-center gap-2 rounded-2xl bg-slate-100 px-3 py-2 text-sm font-bold text-slate-700 dark:bg-slate-800 dark:text-slate-200">
              <FaShieldAlt />
              Rôle administrateur requis
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}